// Client-side helpers for the per-user rulebook. `ruleId` must produce the
// same id as functions/modules/rulebook/rules.js (sha1 of the normalized
// text, 12 hex chars) so a rule added on the profile page and the same rule
// learned server-side collapse into one entry.

export const RULE_CATEGORIES = [
  "language",
  "style",
  "format",
  "content",
  "process",
];
export const MAX_RULE_CHARS = 140;
export const MAX_STORED_RULES = 60;

export function normalizeRuleText(text) {
  return String(text || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^a-z0-9\s]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function cleanRuleText(text) {
  let s = String(text || "")
    .replace(/[`#*_>]/g, "")
    .replace(/\s+/g, " ")
    .trim();
  if (s.length > MAX_RULE_CHARS) {
    s = s.slice(0, MAX_RULE_CHARS - 1).replace(/\s+\S*$/, "") + "…";
  }
  return s;
}

export async function ruleId(text) {
  const bytes = new TextEncoder().encode(normalizeRuleText(text));
  const digest = await crypto.subtle.digest("SHA-1", bytes);
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("")
    .slice(0, 12);
}

export function emptyRulebook(uid) {
  return { uid, enabled: true, rules: [], updatedAt: 0 };
}
